import { render, staticRenderFns } from "./EditorFormButton.vue?vue&type=template&id=1a7d5d56&"
import script from "./EditorFormButton.vue?vue&type=script&lang=js&"
export * from "./EditorFormButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports